import React from 'react';
import { Button } from '@material-ui/core';
import AdrenaLogo from "assets/img/Icon.jpg";
import './ParticipantsWidget.scss';

function ParticipantsWidget({Request, isLogged, ApplicationStore}) {

  if (!Request) return '';

  return (
    <div className="participants-widget">
      <h1>Participantes ({Request.person})</h1>
      <ul className={`participants-list ${!isLogged && 'not-logged'}`}>
        {Request.reserves.map((reserve, index) => {
          if (!isLogged && index < 7) {
            return (
              <li key={reserve.pk_reserve}>
                <img src={(reserve.user && reserve.user.photo) || AdrenaLogo} alt="avatar"/>
                <span>{reserve.name}</span>
              </li>
            );
          } else if (isLogged) {
            return (
              <li key={reserve.pk_reserve}>
                <img src={(reserve.user && reserve.user.photo) || AdrenaLogo} alt="avatar"/>
                <span>{reserve.name}</span>
              </li>
            );
          } else return '';
        })}
      </ul>
      {(!isLogged && Request.reserves.length > 7) && <SkeletonParticipants ApplicationStore={ApplicationStore} />}
    </div>
    );
}

function SkeletonParticipants({ ApplicationStore }) {
  return (
    <div className="skeleton-list">
      <li>
        <div className="skeleton-avatar" />
      </li>
      <li>
        <div className="skeleton-avatar" />
      </li>
      <li>
        <div className="skeleton-avatar" />
      </li>
      <li>
        <div className="skeleton-avatar" />
      </li>
      <li>
        <div className="skeleton-avatar" />
      </li>
      <li>
        <div className="skeleton-avatar" />
      </li>
      <li>
        <div className="skeleton-avatar" />
      </li>
      <Button 
        variant="outlined" 
        color="secondary" 
        className="button-see-more"
        onClick={() => ApplicationStore.openModalLogin()}
      >
        Ver quem já está dentro
      </Button>
    </div>
  );
}

export default ParticipantsWidget;